import React from 'react';
import './SuperAdminDashboard.css';
import moment from 'moment';

const AdminActivity = ({ activity }) => {
    return (
        <div className="admin-activity-card">
            <h5 className="card-title mb-3">Recent Activity</h5>
            {(!activity || activity.length === 0) ? (
                <div className="text-muted text-center py-3">No recent activity.</div>
            ) : (
                <ul className="activity-list">
                    {activity.map((item, index) => (
                        <li key={index} className="activity-item">
                            <div className="activity-icon">
                                <i className="fa fa-info-circle"></i>
                            </div>
                            <div className="activity-content">
                                <span className="activity-desc">{item.description}</span>
                                <span className="activity-date">{moment(item.date).fromNow()}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AdminActivity;
